import classes from './index.module.scss';
import { CircularProgress } from '@mui/material';

const LoadingScreen = ({ message = 'Loading...' }) => {
  return (
    <>
      <div className={classes.loader}>
        <div className={classes.spin}>
          <CircularProgress size="16px" />
        </div>
        <div>
          <p className={classes.loaderText}>{message}</p>
        </div>
      </div>
    </>
  );
};

export default LoadingScreen;
